import React from 'react'
import { findWordInArray } from 'utils/helperFunction'
import Word from './Word'
import { AppUseSelector } from '../../redux/hooks'

interface IOneLineContentProps {
  iterator: any
  contentDetail: any
  wordObj: any
  WIndex: number
  story: any
  activeIndex?: any
  handleClickWord: any
  chineseWordFontSize?: {
    storyContent?: string
    pinyinValue?: string
  }
  showPinYin: boolean
  isFontBold?: boolean
  /** The reading this occurrence has in its sentence (context-matched senses), over the segmentation pinyin. */
  textPinyin?: string | null
}

const OneLineContent: React.FC<IOneLineContentProps> = ({
  contentDetail,
  story,
  activeIndex,
  handleClickWord,
  iterator,
  wordObj,
  WIndex,
  chineseWordFontSize,
  showPinYin,
  isFontBold,
  textPinyin,
}) => {
  const { credentials } = AppUseSelector(({ user }) => user)
  const characterPreference = credentials?.customFields?.character
  const stripedWord = wordObj.word.replace(/<[^>]+>/g, '')
  if (!stripedWord.length) return null
  const newWord =
    story?.newWordsArray?.length > 0 ? findWordInArray(stripedWord, characterPreference, story?.newWordsArray) : false
  const learningWord =
    story?.learningWords?.length > 0 ? findWordInArray(stripedWord, characterPreference, story?.learningWords) : false
  const growingWord =
    story?.growingWords?.length > 0 ? findWordInArray(stripedWord, characterPreference, story?.growingWords) : false
  const developingWord =
    story?.developingWords?.length > 0
      ? findWordInArray(stripedWord, characterPreference, story?.developingWords)
      : false
  const masteredWord =
    story?.masteredWords?.length > 0 ? findWordInArray(stripedWord, characterPreference, story?.masteredWords) : false
  const isLearningWord = story?.learningWords?.length > 0 ? !!learningWord : false
  const isOldWord = story?.oldWords?.includes(wordObj?.word) || false

  const isNewWord = story?.newWordsArray?.length
    ? !!newWord
    : story?.newWord1 === wordObj?.word || story?.newWord2 === wordObj?.word

  const isIncludePTag =
    wordObj.word.includes('<p>') || wordObj.word.includes('</p>') || wordObj.word.includes('</p><p>')
  return (
    <React.Fragment key={`${iterator}${WIndex}`}>
      {isIncludePTag && WIndex ? <br /> : ''}

      <Word
        key={WIndex}
        index={`${iterator}${WIndex}`}
        isActive={`${iterator}${WIndex}` === activeIndex}
        text={stripedWord}
        isNewWord={isNewWord}
        isGrowingWord={!!growingWord}
        isDevelopingWord={!!developingWord}
        isMasteredWord={!!masteredWord}
        isLearningWord={isLearningWord}
        isOldWord={!isNewWord && isOldWord}
        textObj={wordObj}
        sentence={contentDetail}
        onClick={handleClickWord}
        pinYinText={showPinYin ? textPinyin || wordObj?.pinyin : null}
        chineseWordFontSize={isFontBold ? '30px' : chineseWordFontSize?.storyContent}
        pinyinFontSize={chineseWordFontSize?.pinyinValue}
      />
    </React.Fragment>
  )
}

export default React.memo(OneLineContent)
